import axiosInstance, { endpoints } from "src/lib/axios";
import { IKundfaktura } from "src/types/nya/ekonomi/faktura/modell/Kundfaktura";

export interface IKundfakturaFörslag {
    id: string;
    orgId: string;
    uppladdatAv: string;
    filnamn: string;
    status: string;
    uppladdadVid: string;
    url: string;
    felmeddelande: string;
    underlagId?: string;
    affärshändelseId?: string;
    betalningAffärshändelseId?: string;
    matchadBetalning?: boolean;
    banktransaktionId?: string;
    banktransaktionBelopp?: number;
    banktransaktionReferens?: string;
    banktransaktionBokfördPå?: string;
}

export function laddaUppKundfakturorParallellt(filer: File[], orgId: string): Promise<IKundfakturaFörslag[]> {
    const formData = new FormData();
    for (let i = 0; i < filer.length; i++) {
        formData.append('kundfakturaFiler', filer[i]);
    }
    return axiosInstance.post(endpoints.kundfaktura.filuppladdning(orgId), formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data);
}

export function hämtaStatusFörAllaKundfakturor(ids: string[]): Promise<IKundfakturaFörslag[]> {
    return axiosInstance.post(endpoints.kundfaktura.status, ids)
        .then(response => response.data);
}

export function raderaAllaKundfakturor(orgId: string): Promise<void> {
    return axiosInstance.delete(endpoints.kundfaktura.radera(orgId));
}

export function hämtaAllaKundfakturor(orgId: string): Promise<IKundfakturaFörslag[]> {
    return axiosInstance.get(endpoints.kundfaktura.hämta(orgId))
        .then(response => response.data);
}

/**
 * Hämtar samtliga kundfakturaförslag inklusive redan bokförda. Används för
 * översiktsvyer (t.ex. dashboardkortet) där även bokförda fakturor ska visas.
 * Standard-GET utan flaggan filtrerar bort bokförda (arbetskön "att bokföra").
 */
export function hämtaAllaKundfakturorInklBokförda(orgId: string): Promise<IKundfakturaFörslag[]> {
    return axiosInstance.get(endpoints.kundfaktura.hämta(orgId), { params: { inkluderaBokforda: true } })
        .then(response => response.data);
}

export function markeraKundfakturaBokförd(orgId: string, underlagId: string): Promise<void> {
    return axiosInstance.put(endpoints.kundfaktura.markeraBokförd(orgId, underlagId))
        .then(response => response.data);
}

export function automatchaBetalningar(orgId: string): Promise<any[]> {
    return axiosInstance.post(endpoints.kundfaktura.automatchaBetalningar(orgId))
        .then(response => response.data);
}
